import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/layout'

var data = require('../../xml/contactlinks.json');

const Contact = () => {
  const links = data.root.links.link.map((l, i) => (
    <p key={`k${i}`}>
      <a href={l.url} target="_blank">
        {l['$t']}
      </a>
    </p>
  ))

  return (
    <Layout>
      <div className="narrowcontentcolumn">
        <header>
          <div className="close">
            <Link to={'/empty/'} alt="Close">Close<img src="/img/x.gif" /></Link>
          </div>
          <h3>
            YELLO contact
          </h3>
        </header>
        <div className="narrowcontent">
          <div className="inner">
            <h2 className="mobile-only">CONTACT<br/>&#8211;</h2>
            {links}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Contact
